import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {bindActionCreators} from 'redux';
import FlatButton from 'material-ui/FlatButton';
import * as actionCreators from '../actions';

export class UserPanel extends Component {

   constructor(props) {
      super(props);

      this.login = this.login.bind(this);
      this.logout = this.logout.bind(this);
   }

   login(e) {
      e.preventDefault();
      const {dispatch} = this.props;
      dispatch(push('/login'));
   }

   logout(e) {
      e.preventDefault();
      const {actions} = this.props;
      actions.logoutAndRedirect();
   }

   render() {
      const {isAuthenticated, userName} = this.props;
      const btnLabelStyle = {
         color: '#fff'
      };
      return (
         <div style={{marginTop: 4, marginRight: 8}}>
            {isAuthenticated ?
               <FlatButton label={userName}
                           labelStyle={btnLabelStyle}
                           onTouchTap={this.logout}
                           disableTouchRipple={true}
                           hoverColor={'rgba(0, 0, 0, 0)'}
                           style={{cursor:'text', margin:0}}/> : ""
            }
         </div>
      );
   }
}

UserPanel.propTypes = {
   isAuthenticated: PropTypes.bool,
   userName: PropTypes.string
};

function mapStateToProps(state) {
   return {
      isAuthenticated: state.auth.isAuthenticated,
      userName: state.auth.userName
   }
};

const mapDispatchToProps = (dispatch) => ({
   actions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPanel);



// WEBPACK FOOTER //
// ./src/components/UserPanel.js